export default __webpack_public_path__ + "static/media/Image-6.be339ef4.png";